import { analyticContentMetricsActions } from 'store/actions';
import { IAnalyticContentMetricsMeta } from 'store/actions/analytics/contentMetrics';
import { GenericResponse } from 'types/GenericResponse';
import { createAsyncReducer } from 'utils/Redux';

export default createAsyncReducer<IAnalyticContentMetricsMeta, GenericResponse>(
  analyticContentMetricsActions,
);
